/* ============================================================
   MICTLÁN — Compra rápida (snippets/mx-compra-rapida.liquid)
   ============================================================
   Botón [data-mx-rapida="<handle>"] → trae /products/<handle>?view=mx-rapida
   (templates/product.mx-rapida.liquid: el producto + el color de cada valor
   de «Color» con la misma regla que la ficha, para que las muestras sean
   iguales: círculos de color en lugar de pills),
   llena el <dialog id="mx-rapida"> y lo abre. Cada opción (Color,
   Tipo de relleno…) es una fila de pills; al elegir se busca la
   variante, se actualizan foto, precio y data-variant-id del botón
   «Agregar al carrito» (amatora-add-to-cart hace el POST).
   Al agregar se cierra el panel: assets/mx-carrito.js abre el carrito
   (no lo abre si hay otro <dialog> abierto).
   ============================================================ */
(function () {
  'use strict';

  var dlg = document.getElementById('mx-rapida');
  if (!dlg) return;

  var $ = function (sel) { return dlg.querySelector(sel); };
  var cache = {};
  var producto = null;
  var muestras = [];
  var elegidas = [];

  function dinero(centavos) {
    var formato = dlg.dataset.formato || '${{amount}}';
    var n = centavos / 100;
    var con = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var sin = Math.round(n).toLocaleString('en-US');
    return formato.replace(/\{\{\s*amount_no_decimals\s*\}\}/, sin).replace(/\{\{\s*amount\s*\}\}/, con);
  }

  function imagen(url, ancho) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + ancho;
  }

  /** Nombres de las opciones: /products/x.js trae strings u objetos según la versión. */
  function nombresOpciones(p) {
    return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function valoresDe(p, i) {
    var vistos = [];
    p.variants.forEach(function (v) {
      var val = v.options[i];
      if (vistos.indexOf(val) < 0) vistos.push(val);
    });
    return vistos;
  }

  /** Selección obligatoria (snippets/mx-variante-obligatoria.liquid): nada viene elegido de inicio. */
  function obligatoria() {
    return !!(window.mxVariantes && window.mxVariantes.activa);
  }

  function completa() {
    var n = nombresOpciones(producto).length;
    for (var i = 0; i < n; i++) if (elegidas[i] === undefined) return false;
    return true;
  }

  /** Primera variante (disponible si hay) que coincide con lo elegido hasta ahora. */
  function parcial(valores) {
    var coinciden = producto.variants.filter(function (v) {
      for (var j = 0; j < valores.length; j++) if (valores[j] !== undefined && v.options[j] !== valores[j]) return false;
      return true;
    });
    return coinciden.filter(function (v) { return v.available; })[0] || coinciden[0] || null;
  }

  /** «Relleno» se muestra como en la ficha: «Tipo de relleno». */
  function etiqueta(nombre) {
    return /^relleno$/i.test(nombre) ? 'Tipo de relleno' : nombre;
  }

  function faltantes() {
    var nombres = nombresOpciones(producto);
    // En el orden en que se ven: el color al final (como pintarOpciones).
    return nombres.map(function (n, i) { return i; })
      .filter(function (i) { return elegidas[i] === undefined; })
      .sort(function (x, y) {
        return (/colou?r/i.test(nombres[x]) ? 1 : 0) - (/colou?r/i.test(nombres[y]) ? 1 : 0) || x - y;
      });
  }

  function textoAviso(faltan) {
    var nombres = nombresOpciones(producto);
    var lista = faltan.map(function (i) { return etiqueta(nombres[i]).toLowerCase(); });
    var txt = lista.length > 1 ? lista.slice(0, -1).join(', ') + ' y ' + lista[lista.length - 1] : lista[0];
    return String(window.mxVariantes.aviso || 'Elige [opcion] para continuar').replace(/\[opcion\]/g, txt);
  }

  function buscar(valores) {
    for (var i = 0; i < producto.variants.length; i++) {
      var v = producto.variants[i];
      var ok = true;
      for (var j = 0; j < valores.length; j++) if (v.options[j] !== valores[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  /** «ROSA» → «Rosa» (los valores vienen en mayúsculas de WooCommerce, como en la ficha). */
  function bonito(txt) {
    if (txt !== txt.toUpperCase()) return txt;
    var b = txt.toLowerCase();
    return b.charAt(0).toUpperCase() + b.slice(1);
  }

  function pintarOpciones() {
    var cont = $('[data-r-opciones]');
    cont.replaceChildren();
    var nombres = nombresOpciones(producto);
    if (producto.variants.length <= 1) { cont.hidden = true; return; }
    cont.hidden = false;

    // Como en la ficha (blocks/mx-pdp-estilo): primero las opciones de texto y el color al final.
    var orden = nombres.map(function (n, i) { return i; }).sort(function (x, y) {
      return (/colou?r/i.test(nombres[x]) ? 1 : 0) - (/colou?r/i.test(nombres[y]) ? 1 : 0) || x - y;
    });
    orden.forEach(function (i) {
      var nombre = nombres[i];
      var grupo = document.createElement('fieldset');
      grupo.className = 'flex-amatora flex-col-amatora gap-2-amatora m-0-amatora p-0-amatora border-0-amatora';
      var leyenda = document.createElement('legend');
      leyenda.className = 'text-xs-amatora font-semibold-amatora uppercase-amatora p-0-amatora mb-2-amatora';
      leyenda.innerHTML = '';
      leyenda.append(etiqueta(nombre) + ': ');
      var actual = document.createElement('span');
      actual.className = 'font-normal-amatora normal-case-amatora';
      actual.dataset.rActual = i;
      leyenda.append(actual);
      grupo.append(leyenda);

      var fila = document.createElement('div');
      var colores = muestras[i];
      fila.className = 'flex-amatora flex-wrap-amatora ' + (colores ? 'gap-1-amatora' : 'gap-2-amatora');
      valoresDe(producto, i).forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        var m = colores && colores[val];
        if (m && (m.color || m.imagen)) {
          // Muestra de color, como la ficha (blocks/mx-pdp-estilo): círculo con anillo al elegirla.
          b.className = 'rapida-mx__muestra';
          b.setAttribute('aria-label', bonito(val));
          b.title = bonito(val);
          var c = document.createElement('span');
          c.className = 'rapida-mx__circulo';
          c.style.background = m.imagen ? 'center / cover no-repeat url("' + m.imagen + '")' : m.color;
          b.append(c);
        } else {
          b.className = 'rapida-mx__pill px-4-amatora text-xs-amatora font-bold-amatora uppercase-amatora';
          b.textContent = val;
        }
        b.dataset.indice = i;
        b.dataset.valor = val;
        b.addEventListener('click', function () {
          elegidas[i] = val;
          // Si la combinación (completa) no existe, se toma la primera variante disponible con este valor.
          if (completa() && !buscar(elegidas)) {
            var alt = producto.variants.filter(function (v) { return v.options[i] === val; });
            var mejor = alt.filter(function (v) { return v.available; })[0] || alt[0];
            if (mejor) elegidas = mejor.options.slice();
          }
          actualizar();
        });
        fila.append(b);
      });
      grupo.append(fila);
      cont.append(grupo);
    });
  }

  function actualizar() {
    var lista = completa();
    // Sin elegir todo, foto y precio son de la primera variante que coincide con lo elegido.
    var v = (lista && buscar(elegidas)) || parcial(elegidas) || producto.variants[0];

    dlg.querySelectorAll('[data-r-opciones] button[data-valor]').forEach(function (b) {
      var i = +b.dataset.indice;
      b.setAttribute('aria-pressed', String(elegidas[i] === b.dataset.valor));
      var prueba = elegidas.slice();
      prueba[i] = b.dataset.valor;
      var w = parcial(prueba);
      if (w && w.available) b.removeAttribute('data-agotado');
      else b.setAttribute('data-agotado', '');
    });
    var sinElegir = obligatoria() ? (window.mxVariantes.sinElegir || '') : '';
    dlg.querySelectorAll('[data-r-actual]').forEach(function (s) {
      var val = elegidas[+s.dataset.rActual];
      s.textContent = val === undefined ? sinElegir : bonito(val);
      s.toggleAttribute('data-sin-elegir', val === undefined);
      var grupo = s.closest('fieldset');
      if (val !== undefined && grupo) grupo.removeAttribute('data-falta');
    });
    var aviso = $('[data-r-aviso]');
    if (lista) aviso.hidden = true;
    else if (!aviso.hidden) aviso.textContent = textoAviso(faltantes());

    $('[data-r-precio]').textContent = dinero(v.price);
    var antes = $('[data-r-antes]');
    antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';

    var img = (v.featured_image && v.featured_image.src) || producto.featured_image;
    if (img) $('[data-r-img]').src = imagen(img, 300);

    var url = lista ? producto.url + '?variant=' + v.id : producto.url;
    dlg.querySelectorAll('[data-r-link]').forEach(function (a) { a.href = url; });

    var btn = $('[data-r-agregar]');
    btn.dataset.variantId = lista ? v.id : '';
    // Incompleto: el botón sigue activo; al picarlo se avisa qué falta (ver más abajo).
    btn.disabled = lista && !v.available;
    $('[data-r-agregar-txt]').textContent = lista && !v.available ? 'Agotado' : 'Agregar al carrito';
  }

  function abrir(datos) {
    var p = datos.producto;
    if (!p.url) p.url = datos.url; // product | json no trae url
    producto = p;
    muestras = datos.muestras || [];
    var inicial = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    elegidas = inicial.options.slice();
    if (obligatoria() && p.variants.length > 1) {
      // Solo quedan elegidas las opciones que tienen un único valor.
      elegidas = elegidas.map(function (val, i) { return valoresDe(p, i).length === 1 ? val : undefined; });
    }
    $('[data-r-aviso]').hidden = true;
    $('[data-r-titulo]').textContent = p.title;
    $('[data-r-img]').alt = p.title;
    pintarOpciones();
    actualizar();
    var btn = $('[data-r-agregar]');
    btn.dataset.state = 'idle';
    dlg.showModal();
  }

  function cerrar() {
    if (dlg.open) dlg.close();
  }

  function traer(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raiz + 'products/' + encodeURIComponent(handle) + '?view=mx-rapida')  // sin Accept: application/json, si no Shopify ignora ?view y responde su propio JSON
      .then(function (r) {
        if (!r.ok) throw new Error('producto ' + r.status);
        return r.text();
      })
      .then(function (t) {
        var d = JSON.parse(t);
        if (!d || !d.producto || !d.producto.variants) throw new Error('respuesta inválida');
        return d;
      })
      .then(function (p) {
        cache[handle] = p;
        return p;
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mx-rapida]');
    if (!b) return;
    e.preventDefault();
    if (b.dataset.state === 'loading') return;
    b.dataset.state = 'loading';
    traer(b.dataset.mxRapida)
      .then(function (p) {
        b.dataset.state = 'idle';
        abrir(p);
      })
      .catch(function (err) {
        console.warn('[mx-compra-rapida]', err);
        // Si no se pudo traer el producto, se va a la ficha como antes.
        b.dataset.state = 'idle';
        if (b.dataset.url) window.location.href = b.dataset.url;
      });
  });

  // Falta elegir: no se agrega (corre antes que amatora-add-to-cart, que escucha en document).
  $('[data-r-agregar]').addEventListener('click', function (e) {
    if (!producto || completa()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var faltan = faltantes();
    dlg.querySelectorAll('[data-r-actual]').forEach(function (s) {
      var grupo = s.closest('fieldset');
      if (grupo && faltan.indexOf(+s.dataset.rActual) >= 0) grupo.setAttribute('data-falta', '');
    });
    var aviso = $('[data-r-aviso]');
    aviso.textContent = textoAviso(faltan);
    aviso.hidden = false;
  });

  dlg.querySelector('[data-r-cerrar]').addEventListener('click', cerrar);
  // Clic en el fondo oscuro (fuera de la caja).
  dlg.addEventListener('click', function (e) {
    if (e.target !== dlg) return;
    var r = dlg.getBoundingClientRect();
    var dentro = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!dentro) cerrar();
  });

  document.addEventListener('amatora:cart:added', function (e) {
    if (e.detail && e.detail.button && dlg.contains(e.detail.button)) cerrar();
  });
})();
